import { createTheme } from "@mui/material/styles";
import typography from "./typography";
import overrideComponents from "./overrideComponents";
import palette from "./palette";

// Import font files
import Regular from "../fonts/BasisGrotesqueArabicTrial-Regular.otf";
import Bold from "../fonts/BasisGrotesqueArabicTrial-Bold.otf";
import Light from "../fonts/BasisGrotesqueArabicTrial-Light.otf";
import Medium from "../fonts/BasisGrotesqueArabicTrial-Medium.otf";
import Black from "../fonts/BasisGrotesqueArabicTrial-Black.otf";


import Cookies from "js-cookie";
import languages from "../../localization/Languages";

const currLangCode = Cookies.get("i18next") || "ar";
const currLang = languages.find((l) => l.code === currLangCode);
const direction = currLang.dir || "rtl";

const theme = createTheme({
  direction,
  components: {
    ...overrideComponents(direction),
    MuiCssBaseline: {
      styleOverrides: `
              @font-face {
                font-family: "Basis Grotesque Arabic";
                src: url(${Regular}) format("opentype");
                font-weight: 400;
                font-style: normal;
              }
              @font-face {
                font-family: "Basis Grotesque Arabic";
                src: url(${Bold}) format("opentype");
                font-weight: 700;
                font-style: normal;
              }
              @font-face {
                font-family: "Basis Grotesque Arabic";
                src: url(${Light}) format("opentype");
                font-weight: 300;
                font-style: normal;
              }
              @font-face {
                font-family: "Basis Grotesque Arabic";
                src: url(${Medium}) format("opentype");
                font-weight: 500;
                font-style: normal;
              }
              @font-face {
                font-family: "Basis Grotesque Arabic";
                src: url(${Black}) format("opentype");
                font-weight: 900;
                font-style: normal;
              }
            `,
    },
  },
  palette,
  typography,
});

export default theme;
